import { Languages } from 'lucide-react';
import { useI18n, type LanguagePreference } from '@/i18n';
import { cn } from '@/utils';

export default function LanguageSelect({ className }: { className?: string }) {
  const { preference, setPreference, t } = useI18n();
  return (
    <label className={cn('inline-flex items-center gap-2 text-sm min-w-0', className)}>
      <Languages className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="sr-only">{t('语言')}</span>
      <select
        aria-label={t('语言')}
        value={preference}
        onChange={(event) => setPreference(event.target.value as LanguagePreference)}
        className="h-9 min-w-0 rounded-md border border-input bg-background px-2 text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <option value="system">{t('跟随系统')}</option>
        <option value="zh-CN">简体中文</option>
        <option value="en-US">English</option>
      </select>
    </label>
  );
}
